var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2H5V22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM4 24H22C22.5523 24 23 23.5523 23 23V1C23 0.447715 22.5523 0 22 0H4C2.34315 0 1 1.34315 1 3V21C1 22.6569 2.34315 24 4 24ZM21 2V22H7V2H21ZM14 7C12.8954 7 12 7.89543 12 9C12 10.1046 12.8954 11 14 11C15.1046 11 16 10.1046 16 9C16 7.89543 15.1046 7 14 7ZM10 9C10 6.79086 11.7909 5 14 5C16.2091 5 18 6.79086 18 9C18 11.2091 16.2091 13 14 13C11.7909 13 10 11.2091 10 9ZM9 18C9 15.7909 10.7909 14 13 14H15C17.2091 14 19 15.7909 19 18V19H17V18C17 16.8954 16.1046 16 15 16H13C11.8954 16 11 16.8954 11 18V19H9V18Z",
    fill: "#80919F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonebook);
export default __webpack_public_path__ + "static/media/phonebook.ff0050ea43a62ed61f250ea1f03d93d8.svg";
export { ForwardRef as ReactComponent };